var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-title-list-view", attrs: { id: _vm.id } },
    [
      _c("p", { staticClass: "title" }, [_vm._v("Title")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.dataSetup.title,
              expression: "dataSetup.title"
            }
          ],
          attrs: { placeholder: "Title Page", type: "text" },
          domProps: { value: _vm.dataSetup.title },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.dataSetup, "title", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button-blue",
            attrs: { disabled: !_vm.dataSetup.title },
            on: { click: _vm.submitForm }
          },
          [_vm._v("\n      Apply\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-316a82db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316a82db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalTitleListView.vue
// module id = null
// module chunks = 